import React from 'react';
import { JRCFormFieldRenderer } from '../Common/JRCFormFieldRenderer';
import { JRCInputSelectProps } from './JRCInputSelect.types';
import type { FieldValues } from 'react-hook-form';
import { JRCInputSelectRaw } from './JRCInputSelectRaw';

type SelectOption = { label: string; value: any; resetOptions?: boolean };

export function JRCInputSelect<T extends FieldValues = FieldValues>(
    props: Omit<JRCInputSelectProps<T, SelectOption>, 'getLabel' | 'getValue'>,
) {
    const {
        name,
        control,
        readOnly,
        rules,
        label,
        htmlFor,
        labelIsLegend,
        description,
        helper,
        width,
        margin,
        size,
        labelMargin,
    } = props;
    return (
        <JRCFormFieldRenderer
            name={name}
            control={control}
            readOnly={readOnly}
            rules={rules}
            label={label}
            htmlFor={htmlFor ?? name}
            labelIsLegend={labelIsLegend}
            description={description}
            helper={helper}
            width={width}
            margin={margin}
            labelMargin={labelMargin}
            noLabel={props.noLabel}
            renderFunction={({ onChange, value, ...field }) => {
                const option = props.options?.find((o) => o.value === value);
                if (!option) return <></>;
                return (
                    <JRCInputSelectRaw<T, SelectOption>
                        {...props}
                        value={option as any}
                        onChange={(e) => {
                            onChange(e.value);
                        }}
                        htmlFor={htmlFor ?? name}
                        {...field}
                        required={!!props.rules?.required}
                        size={size ?? 'md'}
                        getLabel="label"
                        getValue="value"
                    />
                );
            }}
        />
    );
}
